'use client';
import { jsx } from 'react/jsx-runtime';
import { Li } from '../list/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const AnchorBarListItem = renderWithRef('AnchorBarListItem', null, (o, s)=>{
    let n = new Set([
        'swan-anchor-bar-list-item'
    ]), { children: m } = o;
    return jsx(RenderComp, {
        root: Li,
        forwardedRef: s,
        classNames: n,
        props: o,
        children: m
    });
});

export { AnchorBarListItem };
